var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 19.5C17 20.8807 15.8807 22 14.5 22H4.5C3.11929 22 2 20.8807 2 19.5L2 9.5C2 8.11929 3.11929 7 4.5 7L14.5 7C15.8807 7 17 8.11929 17 9.5L17 19.5ZM14.5 20.75C15.1904 20.75 15.75 20.1904 15.75 19.5L15.75 9.5C15.75 8.80965 15.1904 8.25 14.5 8.25L4.5 8.25C3.80965 8.25 3.25 8.80964 3.25 9.5L3.25 19.5C3.25 20.1904 3.80964 20.75 4.5 20.75H14.5ZM19.5 15.75C20.1904 15.75 20.75 15.1904 20.75 14.5L20.75 4.5C20.75 3.80964 20.1904 3.25 19.5 3.25L9.5 3.25C8.80964 3.25 8.25 3.80964 8.25 4.5V5.75L7 5.75V4.5C7 3.11929 8.11929 2 9.5 2L19.5 2C20.8807 2 22 3.11929 22 4.5L22 14.5C22 15.8807 20.8807 17 19.5 17H18.25V15.75H19.5Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.625C9.75888 10.625 10.125 10.7495 10.125 11.2188V13.75H12.7812C13.1625 13.75 13.375 14.2411 13.375 14.5C13.375 14.7589 13.1625 15.125 12.7812 15.125H10.125V17.7813C10.125 18.162 9.75888 18.3745 9.5 18.3745C9.24112 18.3745 8.8125 18.162 8.8125 17.7813V15.125H6.21875C5.74997 15.125 5.625 14.7589 5.625 14.5C5.625 14.142 5.74997 13.75 6.21875 13.75H8.8125V11.2188C8.8125 10.7495 9.24112 10.625 9.5 10.625Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeDuplicate);
export default __webpack_public_path__ + "static/media/loree-duplicate.f52c7107116f951d6ea661a8349678cb.svg";
export { ForwardRef as ReactComponent };